export const unauthorizedCountWithLocalStorage = ({ initial }: { initial?: number }): number => {
  const KEY = `${process.env.NEXT_PUBLIC_SERVICE_NAME}-unauthorized-count`
  if (initial) {
    // 初期値が存在する場合は、それを設定する
    localStorage.setItem(KEY, initial.toString())
    return 0
  } else {
    const count = Number.parseInt(localStorage.getItem(KEY) || '0')
    localStorage.setItem(KEY, (count + 1).toString())
    return count
  }
}
